module.exports = __webpack_public_path__ + "assets/img/15.2d673139.png";